import {
    getStyleguideSectionById,
    getStyleguideSections,
} from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideSelectors";
import { StyleguideSectionModel } from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface CreateStyleguideSectionParameter extends StyleguideSectionModel {}

type HandlerType = Handler<CreateStyleguideSectionParameter>;

export const DispatchCreateStyleguideSection: HandlerType = props => {
    const state = props.getState();
    const section = getStyleguideSectionById(state, props.parameter.id);
    const sections = getStyleguideSections(state);

    if (!section) {
        props.dispatch({
            type: "Toolkit/Components/Styleguide/CreateStyleguideSection",
            section: { ...props.parameter },
            sections,
        });
    }
};

export const chain = [DispatchCreateStyleguideSection];

const createStyleguideSection = createHandlerChainRunner(chain, "CreateStyleguideSection");

export default createStyleguideSection;
